
    import TutorialVideo from '@/components/tutorial-video.vue';
    import Vue from 'vue';

    export default Vue.extend({
        head: {
			title: { inner: 'Tennis Court Booking Management for your Club', separator: '|', complement: 'Str8 Sets' },
            meta: [
				{ name: 'description', content: 'Give your members the freedom to play tennis when they want, booking a court via the app. No matter how complex your court booking rules, Str8 Sets can handle them. Pricing by member/non-member, member type, court group, peak/off-peak/lights and more.', id: 'desc'},
                { property: 'og:type', content: 'website' },
				{ property: 'og:url', content: 'https://www.str8sets.com/tennis_court_bookings' },
                { property: 'og:title', content: 'Tennis Court Booking Management for your Club | Str8 Sets' },
                { property: 'og:description', content: 'Give your members the freedom to play tennis when they want, booking a court via the app. No matter how complex your court booking rules, Str8 Sets can handle them. Pricing by member/non-member, member type, court group, peak/off-peak/lights and more.' },
                { property: 'og:image', content: 'https://www.str8sets.com/img/meta_str8sets_tennis_1200x628.jpg' },   
				{ property: 'og:image:alt', content: 'Str8 Sets Tennis Logo and Screenshot' },            
                { name: 'twitter:site', content: 'str8sets' },
				{ name: 'twitter:creator', content: '@str8sets' },
				{ name: 'twitter:card', content: 'summary_large_image' },  
				{ name: 'twitter:url', content: 'https://www.str8sets.com/tennis_court_bookings' },
				{ name: 'twitter:title', content: 'Tennis Court Booking Management for your Club | Str8 Sets' },
                { name: 'twitter:description', content: 'Give your members the freedom to play tennis when they want, booking a court via the app. No matter how complex your court booking rules, Str8 Sets can handle them. Pricing by member/non-member, member type, court group, peak/off-peak/lights and more.' },
				{ name: 'twitter:image', content: 'https://www.str8sets.com/img/meta_str8sets_tennis_1200x628.jpg' },
				{ name: 'twitter:image:alt', content: 'Str8 Sets Tennis Logo and Screenshot' }
            ],
            link: [
      			{ rel: 'canonical', href: 'https://www.str8sets.com/tennis_court_bookings', id: 'canonical' }
			]
        },
        components: {
            'tutorial-video': TutorialVideo
        }
    })
